import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="animate-pulse bg-surface-container-highest"
      [class.rounded-sm]="rounded === 'sm'"
      [class.rounded-md]="rounded === 'md'"
      [class.rounded-full]="rounded === 'full'"
      [style.width]="width"
      [style.height]="height"
    ></div>
  `
})
export class SkeletonComponent {
  @Input() width: string = '100%';
  @Input() height: string = '1rem';
  @Input() rounded: 'sm' | 'md' | 'full' = 'md';
}
